// Follow & Engage — portal entry (owned by the engage feature).
import { Navigate, useSearchParams } from "react-router";
import { RequireIgAccount } from "../../lib/igAccount";
import type { FeatureModule } from "../registry";

const engage: FeatureModule = {
  id: "engage",
  nav: [],
  routes: [
    {
      path: "/engage",
      lazy: async () => {
        const { CampaignsPage } = await import("../outreach/CampaignsPage");
        return {
          Component: () => (
            <RequireIgAccount>
              <CampaignsPage />
            </RequireIgAccount>
          ),
        };
      },
    },
    {
      path: "/engage/new",
      lazy: async () => {
        const BuilderPage = () => { const [p] = useSearchParams(); const preset = p.get("preset") ?? "suggested"; return <Navigate replace to={"/outreach/new?type=engage&preset=" + encodeURIComponent(preset === "competitor" ? "engagers" : preset === "post" ? "likers" : preset)} />; };
        return {
          Component: () => (
            <RequireIgAccount>
              <BuilderPage />
            </RequireIgAccount>
          ),
        };
      },
    },
    {
      path: "/engage/:campaignId",
      lazy: async () => {
        const { CampaignPage } = await import("./CampaignPage");
        return {
          Component: () => (
            <RequireIgAccount>
              <CampaignPage />
            </RequireIgAccount>
          ),
        };
      },
    },
    {
      path: "/engage/:campaignId/edit",
      lazy: async () => {
        const { BuilderPage } = await import("./BuilderPage");
        return {
          Component: () => (
            <RequireIgAccount>
              <BuilderPage />
            </RequireIgAccount>
          ),
        };
      },
    },
  ],
};

export default engage;
